<div class="offer-bottom-popup">
  <ion-card>
    <ion-card-header class="ion-text-center">
      <ion-card-subtitle>
        <span class="ion-text-center">No Internet</span>
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content class="ion-align-self-center">
      <ion-row>
        <ion-col class="ion-align-self-center">
          <ion-row class="text-center mrg-top-10">
            <ion-col>
              <img src="./assets/img/no-internet.svg"/>
            </ion-col>
          </ion-row>
          <ion-row class="text-center mrg-top-10">
            <ion-col>
              <span class="main-title">Connection Error</span>
            </ion-col>
          </ion-row>
          <ion-row class="text-center mrg-top-10">
            <ion-col>
              <span class="desc-text">Something’s not right. Please try</span>
            </ion-col>
          </ion-row>
          <ion-row class="text-center">
            <ion-col>
              <span class="desc-text">checking both wifi/ 4G or try again later.</span>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      
      <ion-row class="text-center" style="margin: 15px;">
        <ion-col>
          <ion-button size="default" shape="round" fill='outline' class="retry-btn" (click)="doRetry()">
            Retry
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
</div>